import { Box, Collapse } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput';
import CustomFormSelect from 'components/inputs/CustomFormSelect/CustomFormSelect';

import { filterUserRolesList, filterUserStatusList } from 'common/constants';
import { UsersFiltersDto } from 'types/dto/UsersFiltersDto';

interface Props {
  open: boolean;
  initialValues: UsersFiltersDto;
  loading: boolean;
  onApply: (filters: UsersFiltersDto) => void;
  onReset: () => void;
}

export default function UsersFilters({
  open,
  initialValues,
  loading,
  onApply,
  onReset,
}: Props) {
  const methods = useForm<UsersFiltersDto>({
    defaultValues: initialValues,
  });

  const { handleSubmit, reset } = methods;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        sx={{
          px: 2,
          py: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(onApply)}
            display="grid"
            gridTemplateColumns={{ xs: '1fr', md: 'repeat(4, 1fr)' }}
            gap={2}
            flex={1}
          >
            {/* Name */}
            <CustomFormTextInput
              name="name"
              floatingLabel='Name'
              register={methods.register}
            />

            {/* Role */}
            <CustomFormSelect
              name="role"
              floatingLabel='Role'
              options={filterUserRolesList}
            />

            {/* Status */}
            <CustomFormSelect
              name="status"
              floatingLabel='Status'
              options={filterUserStatusList}
            />

            {/* Actions */}
            <Box
              display="flex"
              gap={1}
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{
                alignSelf: 'end',
              }}
            >
              <CustomButton
                fullWidth
                text="Reset"
                variant="outlined"
                height={40}
                disabled={loading}
                onClick={() => {
                  reset();
                  onReset();
                }}
              />
              <CustomButton
                fullWidth
                text="Search"
                type="submit"
                height={40}
                loading={loading}
              />
            </Box>
          </Box>
        </FormProvider>
      </Box>
    </Collapse>
  );
}
